import { render, staticRenderFns } from "./guangfu.vue?vue&type=template&id=1fb16093&scoped=true&"
import script from "./guangfu.vue?vue&type=script&lang=js&"
export * from "./guangfu.vue?vue&type=script&lang=js&"
import style0 from "./guangfu.vue?vue&type=style&index=0&id=1fb16093&lang=scss&scoped=true&"
import style1 from "./guangfu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb16093",
  null
  
)

export default component.exports